/**
 * 기사 위치 + 정보 통합 타입 (관제 시스템용)
 */
export interface DriverLocationWithInfo {
  // 위치 정보
  locationId: number;
  driverCode: string;
  latitude: number;
  longitude: number;
  accuracy: number | null;
  recordedAt: string;

  // 기사 정보
  driverName: string | null;
  driverMobileTel: string | null;

  // 차량 정보
  vehicleCode: string | null;
  vehicleNumber: string | null;

  // 배차 상태
  dispatchStatus: DispatchStatus;
  todayOrderCount: number;

  // 현재 진행 중인 주문 정보
  currentOrderSlipCode: string | null;
  currentItemName: string | null;
  currentInLocation: string | null;
  currentOutLocation: string | null;
}

/**
 * 배차 상태
 */
export type DispatchStatus = "NONE" | "DISPATCHED" | "IN_PROGRESS" | "COMPLETED";

/**
 * 배차 상태 라벨
 */
export const DISPATCH_STATUS_LABEL: Record<DispatchStatus, string> = {
  NONE: "배차없음",
  DISPATCHED: "배차완료",
  IN_PROGRESS: "운송중",
  COMPLETED: "완료",
};

/**
 * 배차 상태별 마커 색상
 */
export const DISPATCH_STATUS_COLOR: Record<DispatchStatus, string> = {
  NONE: "#9CA3AF", // 회색
  DISPATCHED: "#3B82F6", // 파란색
  IN_PROGRESS: "#22C55E", // 초록색
  COMPLETED: "#6B7280", // 진한 회색
};
